<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "App",
};
</script>
<style lang="less" scoped>
#app {
  width: 100%;
  height: 100%;
}
</style>
<style lang="less">
*{
  box-sizing: border-box;
}
body {
  .el-popover {
    background: #f5f5f5;
    color: #999;
    border: 1px solid #f5f5f5;
    box-sizing: content-box;
  }
}
</style>